import Request from '../Request';
import staticMarker from '../data/static-marker_mozu-furu';
import tooltipData from '../data/tooltip_mozu-furu';

/**
 * もずふる古墳群マップアプリ用コード
 * TODO: 汎用的に使える部分はモジュール化したい
 *
 * @type {IHMozuFuru}
 */
module.exports = class IHMozuFuru extends IH {
  constructor(options) {
    super(options);
  
    /**
     * 変数
     */
    this.options = options;
    this.searchTargetTypes = [];
    this.initLocationOrigin = {}; // 管理画面で設定された初期位置の保存用
    this._placeTypes = [];
    this.tooltipData = tooltipData;
    
    /**
     * 共通設定
     */
    this.mapOptions.gmap_options_default.mapTypeId = google.maps.MapTypeId.TERRAIN;
    this.mapOptions.gmap_options_default.zoom = 13;
    this.mapOptions.gmap_options_default.minZoom = 10;
    this.mapOptions.gmap_options_default.maxZoom = 19;
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: this.translationsExtend.facet.moundShape.name,
      searchApi: 'search',
      mappingItems: {
        lat:         'lat',
        lng:         'lng',
        image:       'image',
        image_label: this.translationsExtend.attributes.imageLabel,
        name:        this.translationsExtend.attributes.name,
        address:     this.translationsExtend.attributes.address,
        description: this.translationsExtend.attributes.description,
        info:        this.translationsExtend.attributes.info
      },
      sortTarget: {
        mound:       this.translationsExtend.attributes.moundLength,
        era:         this.translationsExtend.facet.era.name,
        haniwa_era: '埴輪編年'
      },
      sortValue: {
        // 日本史時代区分
        eras: {},
        // 埴輪編年時代区分
        haniwa_eras: {
          '三期3・4-1': 1,
          '三期3・4-2': 2,
          '三期3・4-3': 3,
          '三期3・4-4': 4,
          '三期3・4-5': 5,
          '三期5-1': 6,
          '三期5-2': 7,
          '三期5-3': 8,
          '三期5-4': 9,
          '三期5-5': 10,
          '四期6・7-1': 11,
          '四期6・7-2': 12,
          '四期6・7-3': 13,
          '四期6・7-4': 14,
          '四期6・7-5': 15,
          '四期6・7-6': 16,
          '四期6・7-7': 17,
          '四期6・7-8': 18,
          '四期6・7-9': 19,
          '五期8': 20,
          '五期9-1': 21,
          '五期9-2': 22,
          '五期9-3': 23,
          '該当なし': 1000
        }
      },
      firstSelection: this.translationsExtend.facet.candidate.value.yes
    };
    this.defaultSortKey = 'mound';
    this.defaultSortOrder = -1;
    this.sortKey_1 = 'mound';
    this.sortOrder_1 = -1;
    this.sortKey_2 = 'era';
    this.sortOrder_2 = 1;
    this.detailMenus = [
      this.translationsExtend.attributes.kana,
      this.translationsExtend.attributes.address,
      this.translationsExtend.facet.candidate.name,
      this.translationsExtend.facet.area.name,
      this.translationsExtend.attributes.moundLength,
      this.translationsExtend.facet.era.name,
      this.translationsExtend.attributes.culturalProperty,
    ];
    this.indexOfKana = 0;
    this.indexOfCandidate = 2;
    this.indexOfMoundLength = 4;
  
    if (this.locale === 'ja') {
      this.staticMarker = staticMarker.ja;
      this.repositoryOptions.sortValue.eras = {
        "古墳時代前期": 1,
        "古墳時代中期": 2,
        "古墳時代後期": 3,
        "不明": 1000
      };
    } else if (this.locale === 'en') {
      this.staticMarker = staticMarker.en;
      this.repositoryOptions.sortValue.eras = {
        "early Kofun period": 1,
        "mid-Kofun period": 2,
        "late Kofun period": 3,
        "unknown": 1000
      };
      this.detailMenus[1] = this.translationsExtend.facet.district.name;
    }
  
    /**
     * 固有設定
     */
    this.googleAnalyticsCodeDefault = this.options.googleAnalyticsCode;
    this.googleAnalyticsCode = 'UA-58956622-5';
    this.numOfMap = 3;
    this.icon_default = this.icon_file_path + 'base_pin.png';
    this.labelingZoomLevel = 15;
    this.extent = null;               // 閲覧範囲制限
    this.specialSearchPhase = 'off';  // 築造順表示処理の段階
    this.highlightInterval = 1750;
    this.specialFacetValues = [       // 築造順表示対象の古墳データを取得する専用のファセット値
      '三期3・4-1',
      '三期3・4-2',
      '三期3・4-3',
      '三期3・4-4',
      '三期3・4-5',
      '三期5-1',
      '三期5-2',
      '三期5-3',
      '三期5-4',
      '三期5-5',
      '四期6・7-1',
      '四期6・7-2',
      '四期6・7-3',
      '四期6・7-4',
      '四期6・7-5',
      '四期6・7-6',
      '四期6・7-7',
      '四期6・7-8',
      '四期6・7-9',
      '五期8',
      '五期9-1',
      '五期9-2',
      '五期9-3',
      this.translationsExtend.facet.moundLength.value.over200
    ];
    // 古代地形図の表示座標
    this.terrainMapBounds = {
      north: 34.8962,
      south: 34.4518,
      east: 135.7214,
      west: 135.3416
    };
    // 展示モード用の初期位置（「グランフロント大阪・ナレッジキャピタル」）
    this.initLocationOnBigpad = {
      lat: 34.705913,
      lng: 135.494468
    };
    this.kofunBounds = [
      { north: 34.567556, south: 34.55935, east: 135.491493, west: 135.482237 },  // 仁徳
      { north: 34.556472, south: 34.551314, east: 135.479747, west: 135.474499 }, // 履中
      { north: 34.556008, south: 34.553874, east: 135.492028, west: 135.488774 }, // 御廟山
      { north: 34.548960, south: 34.545390, east: 135.500806, west: 135.496153 }, // ニサンザイ
      { north: 34.582889, south: 34.579993, east: 135.595389, west: 135.592374 }, // 津堂
      { north: 34.575025, south: 34.572179, east: 135.618037, west: 135.615406 }, // 允恭
      { north: 34.571376, south: 34.568382, east: 135.614313, west: 135.610322 }, // 仲津姫
      { north: 34.567115, south: 34.563613, east: 135.595596, west: 135.592019 }, // 仲哀
      { north: 34.566248, south: 34.560127, east: 135.611902, west: 135.605593 }, // 応神
      { north: 34.558433, south: 34.556450, east: 135.605530, west: 135.602492 }, // 墓山
      { north: 34.552264, south: 34.549977, east: 135.605578, west: 135.602474 }  // 白鳥
    ];
    this.geolocationBounds = {
      minLat: 34.274057,
      maxLat: 35.051187,
      minLng: 135.091399,
      maxLng: 135.746522
    };
    this.showDetailFromTooltipMode = false;
  }
  
  reset() {
    super.reset();
    this.init();
  }
  
  init() {
    let that = this;
    let urlParams = that.getQueryString();
    let moundShape = that.translationsExtend.facet.moundShape.name;
    let moundLengthName = that.translationsExtend.facet.moundLength.name;
    let moundLengthValue = that.translationsExtend.facet.moundLength.value.over200;
    let moundLengthDetail = that.translationsExtend.attributes.moundLength;
    let moundEra = that.translationsExtend.facet.era.name;
    
    // 展示モード(URLパラメータ: "bigpad=true")の場合、
    // 　・初期位置を「グランフロント大阪・ナレッジキャピタル」に変更する
    // 　・管理画面で設定された初期位置は initLocationOrigin に保存する
    // (※ Mapオブジェクト生成前の処理)
    if ('bigpad' in urlParams) {
      that.initLocationOrigin = that.init_location;
      that.init_location = that.initLocationOnBigpad;
    }
    
    $(that).on('ready', function(){
      that.show_direction_on_marker_click = false;
      
      // GoogleAnalyticsで取得するイベントの設定
      if (ga) {
        // メニューボタンを押した時
        $("#footer").on("click", function (event) {
          let label = $(event.target).text().trim();
          if (label.length > 4) {
            label = label[0] + label[1];
          }
          if (label !== '') {
            ga('send', 'event', 'メニュー', 'メニューボタンを押す', label);
          }
        });
        
        // 詳細パネルを開いた時
        $("#page-place").on("panelopen", function () {
          let label = $(this).find('.iw-name').text() + '（' + $(this).find('.iw-type').text() + '）';
          ga('send', 'event', '詳細パネル', '詳細パネルを開く', label);
    
        });
  
        // 特集パネルの地形図選択ボタンを押した時
        $(".mf-map-selector").on("click", function (event) {
          let label = $(event.target).text().trim();
          if (label !== '') {
            ga('send', 'event', '古代地形図', '地形図選択ボタンを押す', label);
          }
        });
        
        // 特集パネルの築造順表示操作ボタンを押した時
        $(".mf-ctrl-btn").on("click", function (event) {
          let elem = $(event.target);
          let label = elem.text().trim();
          if (label === '') {
            label = elem.find('img').attr('alt');
          }
          if (label !== '') {
            ga('send', 'event', '築造順表示', '表示操作ボタンを押す', label);
          }
        });
  
        // 特集パネルの築造順表示操作ボタンを押した時
        $(".mf-cluster-selector").on("click", function (event) {
          let elem = $(event.target);
          let label = '';
          if (!elem.is('p')) {
            label = elem.text().trim();
          }
          if (label !== '') {
            ga('send', 'event', '築造順表示', '古墳群選択ボタンを押す', label);
          }
        });
      }
  
      // 検索結果タイル表示時は特集メニューを無効化
      $('.ih-expand-result-button').on('click', () => {
        $('.mf-footer-menu-feature').addClass('ui-disabled');
      });
      $('.ih-collapse-result-button').on('click', () => {
        $('.mf-footer-menu-feature').removeClass('ui-disabled');
      });
      
      // 常設(ランドマーク)マーカを表示する [地図の種類に依存しないもの]
      for (let li in that.staticMarker) {
        if (that.staticMarker.hasOwnProperty(li)) {
          if (!that.staticMarker[li].dependency) {
            that.map.createMarker(that.staticMarker[li]);
          }
        }
      }
  
      // GPS現在地連動モードに移行
      $('.js-user-location').on('click', function(){
        let elm = $(this);
        that.shiftToLocationMode().then(function(){
          elm.closest('.ui-popup').popup('close');
        });
        return false;
      });
      
      // 展示モードの場合、
      //　・<body> に bigpadクラスを付与する
      //　・閲覧範囲を制限する
      // (※ Mapオブジェクト生成後の処理)
      if (urlParams.bigpad) {
        $('body').addClass('bigpad');
        this.extent = new google.maps.LatLngBounds(
          new google.maps.LatLng(this.terrainMapBounds.south, this.terrainMapBounds.west),
          new google.maps.LatLng(this.terrainMapBounds.north, this.terrainMapBounds.east)
        );
        that.map.getMap().addListener('center_changed', evt => this.restrictBounds(evt));
      }
      
      // fitBoundsと古墳マーカを設定する
      $(that).on('ihAfterTransformPlacesResponse', (event, request, places) => {
        that.controller.options.fit_bounds = false;
        
        _.forEach(places, function(value, key){
          // ビューポートに対象の古墳が全て収まる場合は、fitBoundsを行わない
          if (that.map.getNorthEnd() < value.lat ||
            that.map.getEastEnd() < value.lng    ||
            that.map.getSouthEnd() > value.lat   ||
            that.map.getWestEnd() > value.lng
          ) {
            that.controller.options.fit_bounds = true;
          }
          
          // 古墳オブジェクトごとにマーカのアイコン画像を設定する
          if ( value.attributes[moundLengthName] === that.translationsExtend.facet.moundLength.value.over200 ) {
            places[key].icon_pin = that.icon_file_path + '0_a_pin.png';
            places[key].icon_min = that.icon_file_path + '0_a_min.png';
          } else {
            if ( value.attributes[moundShape] === that.translationsExtend.facet.moundShape.value.keyholeShaped ||
                 value.attributes[moundShape] === that.translationsExtend.facet.moundShape.value.scallopShaped )
            {
              places[key].icon_pin = that.icon_file_path + '0_b_pin.png';
              places[key].icon_min = that.icon_file_path + '0_b_min.png';
            }
            if ( value.attributes[moundShape] === that.translationsExtend.facet.moundShape.value.round ) {
              places[key].icon_pin = that.icon_file_path + '1_pin.png';
              places[key].icon_min = that.icon_file_path + '1_min.png';
            }
            if ( value.attributes[moundShape] === that.translationsExtend.facet.moundShape.value.square ) {
              places[key].icon_pin = that.icon_file_path + '2_pin.png';
              places[key].icon_min = that.icon_file_path + '2_min.png';
            }
            if ( value.attributes[moundShape] === that.translationsExtend.facet.moundShape.value.unknown ) {
              places[key].icon_pin = that.icon_file_path + '3_pin.png';
              places[key].icon_min = that.icon_file_path + '3_min.png';
            }
          }
        });
      });
      
      // ============================== 古地図表示処理 ==============================
      
      // 各種古地図の地面オーバーレイを生成する
      let mapOverLay = [];
      for (let i = 0; i < that.numOfMap; i++) {
        mapOverLay[i] = new google.maps.GroundOverlay(
          that.place_image_path + 'img/maps/' + (i + 1) + '.jpg',
          that.terrainMapBounds,
          {opacity: 0.65} // 不透明度
        );
      }
  
      // 古墳イラスト用のオーバーレイを作成
      let kofunOverLay = [];
      for (let i = 0; i < 11; i++) {
        kofunOverLay[i] = new google.maps.GroundOverlay(
          that.place_image_path + 'img/illusts/' + i + '.png',
          that.kofunBounds[i]
        );
      }
  
      // 地形図へ切替時のマップアプリの名称の設定
      let mapTitle = $('.mf-map-title');
      let defaultMapTitle = that.options.title;
      let terrainMapTitle = [
        that.options.title + that.translationsExtend.ancientMap.jomon,
        that.options.title + that.translationsExtend.ancientMap.yayoi,
        that.options.title + that.translationsExtend.ancientMap.kofun
      ];
      
      // 古地図選択ボタンを押すと、対象の時代の地図（地面オーバーレイ）を表示する
      $('.mf-map-selector').on('change', () => {
        // 依存生常設マーカが表示されている場合、一度非表示にする
        that.map.clearStaticMarkersAll();
        
        // 一度地図と古墳図を非表示にする（現代地図に戻す）
        for (let i = 0; i < that.numOfMap; i++) {
          mapOverLay[i].setMap(null);
        }
        for (let i = 0; i < 11; i++) {
          kofunOverLay[i].setMap(null);
        }
  
        // 選択が現代地図(value=0)でなければ、地形図・古墳図を表示し、マップアプリの名称を変更する
        let mapType = parseInt($("input[name='map-type']:checked").val(), 10);
        if (mapType > 0) {
          mapOverLay[ mapType - 1 ].setMap(that.map.getMap());
          
          if (mapType === 3) {
            setTimeout( () => {
              for (let i = 0; i < 11; i++) {
                kofunOverLay[i].setMap(that.map.getMap());
              }
            }, 1500);
          }
          
          mapTitle.each(function () {
            $(this).text(terrainMapTitle[ mapType - 1 ]);
          });
        // 現代地図の場合はマップアプリの名称をデフォルトに戻す
        } else {
          mapTitle.each(function () {
            $(this).text(defaultMapTitle);
          });
        }
        
        // 地形図の種類に依存する常設マーカを表示する
        let lid = null;
        for (let key in that.staticMarker) {
          if (that.staticMarker.hasOwnProperty(key)) {
            lid = that.staticMarker[key].id;
            if (that.staticMarker[key].dependency) {
              for (let di = 0; di < that.staticMarker[key].dependentType.length; di++) {
                if (that.staticMarker[key].dependentType[di] === mapType) {
                  that.map.createMarker(that.staticMarker[key]);
                }
              }
            }
          }
        }
      });
  
      // ============================== 築造順表示処理 ==============================
  
      // 築造順テーブルの破線ハイライトされている行数（初期値: 2）
      // 　・行数は本来0スタート
      // 　・tdボトムに枠線デザインが施されている箇所があるため、tdトップに破線を表示
      // 　・1行目(0)と最後はハイライト用の空行
      // 　・テーブル中の古墳以前の、テーブル未表示の古墳(2行目tdトップの破線で表示)は現状無い
      // 　・そのため、3行目(2)tdトップがスタート位置になる
      let trCount = 2;
      // 築造順テーブルの全行（TR, 破線ハイライト対象）
      let allTR = $('.mf-const-table tr');
      // 破線ハイライト対象のTD
      let dottedTD = null;
      // 背景色ハイライト対象のTD
      let colouredTD = null;
      // 検索結果初期化用の空リクエスト
      let emptyReq = new Request({types: []});
      
      // リクエストを生成するためのファセットID情報源としてplaceTypeを取得する
      that._placeTypes = that.placeType.getAll();
  
      // 築造順表示操作ボタンの処理: 自動再生、一時停止、ステップ再生、早送り、表示消去
      $('.mf-ctrl-btn').on('click', function () {
        // 築造順テーブルのハイライトを元に戻す
        let constTD = $('.mf-const-table td');
        constTD.removeClass('highlighting');
        constTD.removeClass('top-dotted');
        
        // 築造順表示操作ボタンのの種類を取得する
        let selectBtn = parseInt($(this).val(), 10);
  
        // 自動再生、早送り
        if (selectBtn === 1 || selectBtn === 4) {
          that.startSpecialSearch(selectBtn);
        }
        // 一時停止
        if (selectBtn === 2) {
          that.pauseSpecialSearch();
        }
        // ステップ再生
        if (selectBtn === 3) {
          that.stepSpecialSearch();
        }
        // 表示消去
        if (selectBtn === 0) {
          // 築造順テーブルのハイライトする行を元に戻す
          trCount = 2;
          that.terminateSpecialSearch();
        }
      });
  
      // 築造順表示用の古墳オブジェクトをリクエスト後の処理
      $(that).on('ihAfterRequestPlaces', (event, request, places) => {
        // 築造順表示処理の段階が「表示中」「表示後」「ステップ再生」の場合
        if (that.specialSearchPhase === 'displaying' ||
            that.specialSearchPhase === 'displayed'  ||
            that.specialSearchPhase === 'stepping') {
  
          // 検索メニューの各データ数を初期化する
          // 築造順表示のための検索は、検索メニューからの検索とは独立に動作させるため
          that.controller.displayNumberOfFacetValue(emptyReq);
  
          // 築造順表示処理の段階が「表示中」「ステップ再生」の場合
          if (that.specialSearchPhase === 'displaying' || that.specialSearchPhase === 'stepping') {
            // 検索メニューの各データ数を初期化することで有効化された検索メニューを再び無効化する
            $('.js-search-type').addClass('ui-disabled');
          }
        }
      });
      
      // 築造順表示用の古墳マーカが１つ表示されるごとの処理
      $(that.map).on('ihDisplayedOneMarker', function (event, places, place, marker, popup){
        // 築造順表示処理の段階が「ステップ再生」の場合
        if (that.specialSearchPhase === 'stepping') {
          // 一時停止を実行する
          that.pauseSpecialSearch();
          // 築造順表示処理の段階を「一時停止」から「ステップ再生」に変更する
          that.specialSearchPhase = 'stepping'
        }
  
        // 築造順表示処理の段階が「表示中」「ステップ再生」の場合
        if (that.specialSearchPhase === 'displaying' || that.specialSearchPhase === 'stepping') {
          // 「自動再生」の場合、対象の古墳マーカのポップアップを開く
          // (「早送り」では開かない)
          if (that.searchSpeed === 'normal') {
            that.map.toggleMarkerPopup(marker, popup);
          }
          
          $('.mf-const-kofun').each(function(){
            let kofunName = $(this).find('.mf-const-kofun-name').text();
            if (kofunName === place.name) {
              // 築造順テーブルの表示中の古墳名の背景を薄緑でハイライトし、文字色を黒にする
              colouredTD = $(this);
              colouredTD.removeClass('before-highlighting');
              colouredTD.addClass('highlighting');
              // 築造順テーブルのハイライトする行を1つ進める
              trCount++;
            }
          });
          
          // 表示対象の古墳が中小規模の場合
          if ( place.attributes[moundLengthName] !== moundLengthValue ) {
            // 破線ハイライト対象のTDを取得する
            if ( place.attributes[ that.translationsExtend.facet.area.name ] === that.translationsExtend.facet.area.value.mozu ) {
              dottedTD = allTR.eq(trCount).find('td').eq(0);
            } else {
              dottedTD = allTR.eq(trCount).find('td').eq(1);
            }
            // 対象のTDを破線でハイライトする
            dottedTD.addClass('top-dotted');
          }
  
          // 築造順表示処理の段階が「ステップ再生」の場合
          if (that.specialSearchPhase === 'stepping') {
            // 築造順表示処理の段階を「一時停止」にする
            // 表示を再開した時に続きから表示するため（ = 一時停止後の処理にするため）
            that.specialSearchPhase = 'pausing';
            // ただし、最後の古墳を表示した後は「表示中」にする
            // 表示後の処理に移るため
            if (place.id === places[ places.length - 1 ].id) {
              that.specialSearchPhase = 'displaying';
            }
            // ハイライトは消さない
            return;
          }
          
          // 1.75秒(自動再生) or 0.75秒(早送り)後
          setTimeout(() => {
            // 背景色ハイライトを消す
            colouredTD.removeClass('highlighting');
            if (place.attributes[moundLengthName] !== moundLengthValue) {
              // 破線ハイライトを消す
              dottedTD.removeClass('top-dotted');
            }
          }, that.highlightInterval);
        }
      });
  
      // 築造順表示用の全古墳マーカが表示された後の処理
      $(that.map).on('ihDisplayedAllMarkers', function (event, places, marker, popup){
        if (that.specialSearchPhase === 'displaying') {
          // 築造順表示処理の段階を「表示後」にする
          that.specialSearchPhase = 'displayed';
          
          // 1.75秒(自動再生) or 0.75秒(早送り)後
          setTimeout(() => {
            // 検索メニュー、並替えボタンを有効化する
            that.disableNormalSearchMenu(false);
            
            // 「一時停止」以外を有効化する
            // 　・disabled = [古墳群の表示をクリア, 自動再生, 一時停止, 次を表示, 早送り]
            // 　・true: 無効化、false: 有効化
            let disabled = [false, false, true, false, false];
            that.disableSpecialSearchMenu(disabled);
  
            // 古墳群選択ボタンを有効化する
            $('.mf-cluster-selector').removeClass('ui-disabled');
            
            if (that.searchSpeed === 'normal') {
              // 対象の古墳マーカのポップアップを開く
              that.map.toggleMarkerPopup(marker, popup);
            }
  
            // 築造順テーブルのハイライトする行を元に戻す
            trCount = 2;
            // 築造順表示専用の検索クエリを空にする
            that.searchTargetTypes = [];
            // 表示間隔を0秒に戻す
            that.map.interval = 0;
          }, that.highlightInterval);
          
        }
        
      });
  
      // 築造順表示モードの場合、検索メニューを選んだ時、築造順表示処理の段階を「オフ」にし、並び替えキーを墳丘長順にする
      $('.js-facet-selector').on('change', function(){
        if (that.specialSearchPhase !== 'off') {
          that.specialSearchPhase = 'off';
          that.repository.sortOrder = -1;
          that.repository.sortKey = 'mound';
          $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
        }
      });
      
      // ズームレベルによって、古墳マーカのラベルの表示・非表示を切替える
      let markerLabel;
      google.maps.event.addListener(that.map.getMap(), 'zoom_changed', function(){
        if (that.map.getMap().getZoom() < that.labelingZoomLevel) {
          $.each(that.map.getDisplayMarkers(), function() {
            this.setLabel(null);
          });
        // 築造順表示モードの場合は、ラベルを表示しない
        } else if (that.map.getMap().getZoom() >= that.labelingZoomLevel && that.specialSearchPhase === 'off'){
          $.each(that.map.getDisplayMarkers(), function() {
            markerLabel = {
              text: this.name,
              color: "#493E26",
              fontSize: "14px",
              fontWeight: '400',
              fontFamily: 'ヒラギノ丸ゴ Pro W4,ヒラギノ丸ゴ Pro,Hiragino Maru Gothic Pro,ヒラギノ角ゴ Pro W3,' +
                          'Hiragino Kaku Gothic Pro,HG丸ｺﾞｼｯｸM-PRO,HGMaruGothicMPRO',
            };
            this.setLabel(markerLabel);
          });
        }
      });
  
      /**
       * ツールチップから詳細パネル表示
       */
      that.showDetailFromTooltip();
    });
  
    // 検索結果一覧に墳丘長と築造時代を表示する
    $(that).on('ihFillSearchResult', (event, place, item) => {
      let text = moundLengthName + ' ' + place.attributes[moundLengthDetail] + ', ' + place.attributes[moundEra];
      item.find('.sr-info').text(text);
    });
    
    // マーカポップアップ・詳細パネルの内容を書換える
    $(that).on('ihFillMarkerPopup', function (event, place, popup) {
      // 詳細パネル: アプリ固有の項目を作成する
      that.createDetailMenus(place, popup);
      // 詳細パネル: 画像ポップアップを作成する
      that.createImagePopup(place, popup);
      // マーカポップアップに墳丘長と築造時代を表示する
      let markerInfo = moundLengthName + ' ' + place.attributes[moundLengthDetail] + ', ' + place.attributes[moundEra];
      popup.find('.iw-desc').text(markerInfo);
    });
  }
  
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  }
  
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes() {
    let types = [];
    for (let i in this.searchTargetTypes) {
      if (this.searchTargetTypes[i]) {
        types.push(i);
      }
    }
    return types;
  }
  
  /**
   * 詳細パネル: アプリ固有の項目を作成する
   *
   * @param place
   * @param popup
   */
  createDetailMenus(place, popup){
    for (let i = 0, len = this.detailMenus.length; i < len; i++ ) {
      let attr = this.detailMenus[i];
      let text = '';
      
      // 施設オブジェクトに項目名と同じプロパティあれば、プロパティ値を項目の内容として表示
      if (attr in place.attributes) {
        text = place.attributes[attr];
        
        if ( i === this.indexOfCandidate && text === this.translationsExtend.facet.candidate.value.yes ) {
          let number = place.attributes[ this.translationsExtend.attributes.no ];
          text += '（' + number + '）';
          popup.find('.mf-kofun-number').text( '(' + number.toString() + ') ' );
        }
        if ( i === this.indexOfMoundLength ) {
          attr = this.translationsExtend.facet.moundLength.name;
        }
        
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').find('.iw-label').text(attr);
        popup.find('.iw-facet-' + (i+1)).html(text);
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').show();
        
        if ( this.locale === 'en' && i === this.indexOfKana ) {
          popup.find('.iw-facet-' + (i+1)).closest('.iw-item').hide();
        }
      } else {
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').hide();
      }
    }
  }
  
  /**
   * 詳細パネル: 画像スライダー付きポップアップウィンドウを作成する
   *
   * @param place
   * @param popup
   */
  createImagePopup(place, popup){
    if ( place.image && popup.find('.iw-image-popup').length ){
      let imagePath = place.image;
      if (!imagePath.match(/^http/)) {
        imagePath = this.place_image_path + imagePath;
      }
  
      popup.find('.iw-image-popup').show();
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
      let imagePopup = $('#image-popup');
      
      // 画像ポップアップウィンドウとスライダの作成
      if ( imagePopup.length === 0 ){
        imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
        imagePopup.popup();
        
        // ポップアップを閉じるボタンを追加
        let closer = $('<button id="image-popup-closer" data-theme="b" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b">' + this.translationsExtend.ui.close + '</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
        
        // ポップアップを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      }
      
      $('#image-slider').remove();
      $('.bx-wrapper').remove();
      
      // スライダー用のdiv要素を作成し、ポップアップウィンドウに追加
      let imageSlider = $('<div id="image-slider"></div>');
      imageSlider.appendTo(imagePopup);
  
      let title = place.name + '（' + place.attributes[ this.translationsExtend.facet.moundShape.name ] + '）';
      $('<div class="sliding-images"><img src="' + imagePath + '" title="' + title + '" id="sliding-image-' + 0 + '"></div>').appendTo(imageSlider);
      
      // ポップアップウィンドウの表示完了後にスライダを作成
      // これまでスライド作成できない不具合があったのは、恐らくポップアップ表示完了前にスライダが生成されいたため
      imagePopup.on( "popupafteropen", ( event, ui )=> {
        imageSlider.bxSlider({
          minSlides: 1,
          maxSlides: 1,
          slideMargin: 5,
          infiniteLoop: false,
          hideControlOnEnd: true,
          captions: true,
          // 画像遅延ロード
          // onSlideBefore: function($slideElement, oldIndex, newIndex){
          //   $('#sliding-image-' + newIndex).attr('src', imagePaths[newIndex]);
          // }
        });
      });
    }else{
      popup.find('.iw-image-popup').hide();
    }
    
    if (place.image_label && popup.find('.iw-image-label').length){
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').text(place.image_label);
    }else{
      popup.find('.iw-image-label-item').hide();
    }
  }
  
  /**
   * 閲覧範囲を制限する
   *
   */
  restrictBounds() {
    if (this.extent.contains(this.map.getCenter())) {
      return;
    }
    
    let maxLat = this.extent.getNorthEast().lat(),
        maxLng = this.extent.getNorthEast().lng(),
        minLat = this.extent.getSouthWest().lat(),
        minLng = this.extent.getSouthWest().lng(),
        lat = this.map.getCenter().lat(),
        lng = this.map.getCenter().lng();
  
    if (maxLat < lat) {
      lat = maxLat;
    }
    if (maxLng < lng) {
      lng = maxLng;
    }
    if (minLat > lat) {
      lat = minLat;
    }
    if (minLng > lng) {
      lng = minLng;
    }
  
    this.map.setCenter(this.map.createLatLng(lat, lng));
  }
  
  /**
   * 未表示の施設オブジェクトを取得する
   */
  getNotDisplayedPlaces(){
    // 表示中のマーカを取得
    let markers = this.map.getDisplayMarkers();
    // 表示予定の施設オブジェクトを取得
    let places = this.map.getDisplayingPlaces();
    
    // 未表示の施設オブジェクトを返す
    _.remove(places, function(place){
      let flag = false;
      for (let key in markers) {
        if (place.id == key) {
          flag = true;
          break;
        }
      }
      return flag;
    });
    return places;
  }
  
  /**
   * 築造順表示の自動再生・早送りの処理
   *
   * @param mode - 再生モード(1: 自動再生, 4: 早送り)
   */
  startSpecialSearch(mode){
    // 「古墳群の表示をクリア」「自動再生」「次を表示」「早送り」を無効化する
    // 「一時停止」は、「自動再生」の時は有効化、「早送り」の時は無効化する
    // 　・disabled = [古墳群の表示をクリア, 自動再生, 一時停止, 次を表示, 早送り]
    // 　・true: 無効化、false: 有効化
    let disabled = [true, true, mode === 4, true, true];
    this.disableSpecialSearchMenu(disabled);
    
    if (mode === 4) {
      this.map.closeMarkerPopup();
    }
    
    // 築造順表示処理の段階が「一時停止」の場合、表示を再開する
    if (this.specialSearchPhase === 'pausing') {
      // 再生速度(マーカ描画間隔、ハイライト間隔)を設定する
      this.setPlaySpeed(mode);
      // 未表示の古墳オブジェクトを取得する
      let places = this.getNotDisplayedPlaces();
      // 築造順表示処理の段階を「表示中」にする
      this.specialSearchPhase = 'displaying';
      // 未表示の古墳を表示する
      this.map.displayMarkers(null, places);
      return;
    }
  
    // 築造順表示処理の段階を「表示中」にする
    this.specialSearchPhase = 'displaying';
    // 検索メニュー、並替えボタンを無効化する
    this.disableNormalSearchMenu(true);
    // 古墳群選択ボタンを無効化する
    $('.mf-cluster-selector').addClass('ui-disabled');
    // 築造順テーブルの古墳名を灰色にする(グレーアウト)
    // 築造順表示と共に以下のように色を変化させて、表示状態を伝える
    // 　・未表示: 文字（灰色）
    // 　・表示中: 文字（黒色）＋ 背景（緑色）
    // 　・表示済: 文字（黒色）
    $('.mf-const-table td').addClass('before-highlighting');
    // 築造順表示用の検索設定を行う（リポジトリ、再生速度、検索メニュー）
    this.initSpecialSearch(mode);
    // 築造順表示用の検索クエリを生成する
    this.setSpecialSearchQuery();
    // 古墳データを検索する
    this.searchFromBaseMarker();
  }
  
  pauseSpecialSearch(){
    if (this.specialSearchPhase !== 'displayed') {
      // 築造順表示処理の段階を「一時停止」にする
      this.specialSearchPhase = 'pausing';
    }
    
    // 「一時停止」のみ無効化する
    let disabled = [false, false, true, false, false];
    this.disableSpecialSearchMenu(disabled);
    
    // タイマー表示を停止するIDを取得する
    let timerID = this.map.getTimerID();
    // タイマー表示を停止する（築造順表示の一時停止）
    if (timerID.length !== 0) {
      for (let i = 0; i < timerID.length; i++) {
        clearTimeout(timerID[i]);
      }
    }
  }
  
  stepSpecialSearch(){
    // 検索メニュー、並替えボタンを無効化する
    this.disableNormalSearchMenu(true);
    // 自動再生を実行する（）
    this.startSpecialSearch(1);
    // 築造順表示処理の段階を「ステップ再生」にする
    // 「ステップ再生」中は、自動再生でマーカを１つ表示した後、一時停止がかかる
    this.specialSearchPhase = 'stepping';
  }
  
  terminateSpecialSearch(){
    // 築造順表示処理の段階が「一時停止」の場合
    if (this.specialSearchPhase === 'pausing') {
      // 表示間隔を0秒に戻す
      this.map.interval = 0;
      // 築造順テーブルのグレーアウトを元に戻す
      $('.mf-const-table td').removeClass('before-highlighting');
    }
    
    // 築造順表示処理の段階を「オフ」にする
    this.specialSearchPhase = 'off';
    // 古墳マーカを消去する
    this.searchTargetTypes = [];
    this.searchFromBaseMarker();
    // 検索メニュー、並替えボタンを有効化する
    this.disableNormalSearchMenu(false);
    // 操作ボタンの有効・無効を初期状態に戻す
    let disabled = [true, false, true, false, false];
    this.disableSpecialSearchMenu(disabled);
    // 古墳群選択ボタンを有効化する
    $('.mf-cluster-selector').removeClass('ui-disabled');
    this.repository.sortOrder = -1;
    this.repository.sortKey = 'mound';
    $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
  }
  
  /**
   * 検索パネル、結果パネルの並替えボタンの有効・無効を切替る
   *
   * @param {boolean} disabled
   */
  disableNormalSearchMenu(disabled){
    if (disabled) {
      $('.js-search-type').addClass('ui-disabled');
      $('.ih-list-controller').addClass('ui-disabled');
    } else {
      $('.js-search-type').removeClass('ui-disabled');
      $('.ih-list-controller').removeClass('ui-disabled');
    }
  }
  
  /**
   * 築造順表示操作ボタンの有効・無効を切替る
   * @param {Array} disabled - 各ボタンの設定値
   * @example
   *  disabled = [true, false, false, true, false]
   *  // ボタンの割当て: [古墳群の表示をクリア, 自動再生, 一時停止, 次を表示, 早送り]
   *  // true: 無効化、false: 有効化
   */
  disableSpecialSearchMenu(disabled){
    let i, elem;
    $('.mf-ctrl-btn').each(function () {
      i = parseInt($(this).val(), 10);
      elem = $(this).parent().parent();
      if ( disabled[i] ) {
        elem.addClass('ui-disabled');
      } else {
        elem.removeClass('ui-disabled');
      }
    });
  }
  
  /**
   * 築造順表示用の検索の初期設定を行う
   *
   * @param {Number} mode - 再生モード(1: 自動再生, 4: 早送り)
   */
  initSpecialSearch(mode){
    // 築造順表示ボタンの場合、古墳データの並替え順を設定する
    this.repository.sortOrder = 1;
    // 古墳データの並替えキーを、埴輪編年順に設定する
    this.repository.sortKey = 'haniwa_era';
    $('select.ih-result-sort-menu').val('2').selectmenu('refresh');
    // 再生速度(マーカ描画間隔、ハイライト間隔)を設定する
    this.setPlaySpeed(mode);
    // 検索メニューの選択をクリアする
    this.controller.clearAllSelector();
    this.searchTargetTypes = [];
  }
  
  /**
   * 再生速度(マーカ描画間隔、ハイライト間隔)を設定する
   *
   * @param {Number} mode - 再生モード(1: 自動再生, 4: 早送り)
   */
  setPlaySpeed(mode){
    if (mode === 1) {
      this.searchSpeed = 'normal';
      this.map.interval = 2000;
      this.highlightInterval = 1750;
    }
    if (mode === 4) {
      this.searchSpeed = 'fast-forward';
      this.map.interval = 1000;
      this.highlightInterval = 750;
    }
  }
  
  /**
   * 築造順表示用の検索クエリを生成する
   */
  setSpecialSearchQuery(){
    // 選択されたボタンの種類（大規模 or 大規模＋中小規模）を取得する
    let selectBtn = parseInt($("input[name='cluster']:checked").val(), 10);
    // 築造順表示専用のファセット値(埴輪編年)の組合わせによる、選択値テーブルを設定する
    for (let fi = 0; fi < this.specialFacetValues.length; fi++) {
      for (let pi = 0; pi < this._placeTypes.length; pi++) {
        // 選択したボタンが「大規模＋中小規模」(value=0)の場合、ファセット値「200m以上」は無効にする
        if ( selectBtn === 1 && this.specialFacetValues[fi] === this.translationsExtend.facet.moundLength.value.over200 ) {
          continue;
        }
        if (this.specialFacetValues[fi] === this._placeTypes[pi].name) {
          this.searchTargetTypes[ this._placeTypes[pi].id ] = true;
        }
      }
    }
  }
  
  /**
   * ツールチップから特定の古墳のみ表示する（検索メニューとは独立）
   */
  showDetailFromTooltip(){
    const emptyReq = new Request({types: []}); // 検索結果初期化用の空リクエスト
    const that = this;
    
    $('.mf-tooltip-to-detail').on('click', function () {
      let placeType = $(this).data('kofun');
      let placeTypeId = _.find(that._placeTypes, {name: placeType}).id;
  
      // 築造順表示モードの場合、築造順表示処理の段階を「オフ」にし、並び替えキーを墳丘長順にする
      if (that.specialSearchPhase !== 'off') {
        that.specialSearchPhase = 'off';
        that.repository.sortOrder = -1;
        that.repository.sortKey = 'mound';
        $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
      }
      
      $('.js-tooltip-display').popup('close');
      that.showDetailFromTooltipMode = true;
      that.controller.clearAllSelector();
      that.searchTargetTypes = [];
      that.searchTargetTypes[placeTypeId] = true;
      that.searchFromBaseMarker();
    });
  
    // 検索メニューの選択状態とデータ件数初期化
    // 詳細パネルを開く
    $(that.map).on('ihDisplayedAllMarkers', function (event, places, marker, popup){
      if (that.showDetailFromTooltipMode) {
        let place = places[0];
        let latlng = that.map.createLatLng(place.lat, place.lng);
        that.controller.displayNumberOfFacetValue(emptyReq);
        that.searchTargetTypes = [];
        that.map.setCenter(latlng);
        that.map.focusMarker(place);
        that.showDetailFromTooltipMode = false;
      }
    });
  }
};



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHMozuFuru.js